export interface CountryCurrency {
  code: string;
  country: string;
  currency: string;
}

export const COUNTRY_DATA: CountryCurrency[] = [
  { code: 'AF', country: 'Afghanistan', currency: 'AFN' },
  { code: 'AX', country: 'Aland Islands', currency: 'EUR' },
  { code: 'AL', country: 'Albania', currency: 'ALL' },
  { code: 'DZ', country: 'Algeria', currency: 'DZD' },
  { code: 'AS', country: 'American Samoa', currency: 'USD' },
  { code: 'AD', country: 'Andorra', currency: 'EUR' },
  { code: 'AO', country: 'Angola', currency: 'AOA' },
  { code: 'AI', country: 'Anguilla', currency: 'XCD' },
  { code: 'AQ', country: 'Antarctica', currency: '' },
  { code: 'AG', country: 'Antigua and Barbuda', currency: 'XCD' },
  { code: 'AR', country: 'Argentina', currency: 'ARS' },
  { code: 'AM', country: 'Armenia', currency: 'AMD' },
  { code: 'AW', country: 'Aruba', currency: 'AWG' },
  { code: 'AU', country: 'Australia', currency: 'AUD' },
  { code: 'AT', country: 'Austria', currency: 'EUR' },
  { code: 'AZ', country: 'Azerbaijan', currency: 'AZN' },
  { code: 'BS', country: 'Bahamas', currency: 'BSD' },
  { code: 'BH', country: 'Bahrain', currency: 'BHD' },
  { code: 'BD', country: 'Bangladesh', currency: 'BDT' },
  { code: 'BB', country: 'Barbados', currency: 'BBD' },
  { code: 'BY', country: 'Belarus', currency: 'BYN' },
  { code: 'BE', country: 'Belgium', currency: 'EUR' },
  { code: 'BZ', country: 'Belize', currency: 'BZD' },
  { code: 'BJ', country: 'Benin', currency: 'XOF' },
  { code: 'BM', country: 'Bermuda', currency: 'BMD' },
  { code: 'BT', country: 'Bhutan', currency: 'BTN' },
  { code: 'BO', country: 'Bolivia', currency: 'BOB' },
  { code: 'BQ', country: 'Bonaire Sint Eustatius and Saba', currency: 'USD' },
  { code: 'BA', country: 'Bosnia and Herzegovina', currency: 'BAM' },
  { code: 'BW', country: 'Botswana', currency: 'BWP' },
  { code: 'BV', country: 'Bouvet Island', currency: 'NOK' },
  { code: 'BR', country: 'Brazil', currency: 'BRL' },
  { code: 'IO', country: 'British Indian Ocean Territory', currency: 'USD' },
  { code: 'BN', country: 'Brunei Darussalam', currency: 'BND' },
  { code: 'BG', country: 'Bulgaria', currency: 'BGN' },
  { code: 'BF', country: 'Burkina Faso', currency: 'XOF' },
  { code: 'BI', country: 'Burundi', currency: 'BIF' },
  { code: 'KH', country: 'Cambodia', currency: 'KHR' },
  { code: 'CM', country: 'Cameroon', currency: 'XAF' },
  { code: 'CA', country: 'Canada', currency: 'CAD' },
  { code: 'CV', country: 'Cape Verde', currency: 'CVE' },
  { code: 'KY', country: 'Cayman Islands', currency: 'KYD' },
  { code: 'CF', country: 'Central African Republic', currency: 'XAF' },
  { code: 'TD', country: 'Chad', currency: 'XAF' },
  { code: 'CL', country: 'Chile', currency: 'CLP' },
  { code: 'CN', country: 'China', currency: 'CNY' },
  { code: 'CX', country: 'Christmas Island', currency: 'AUD' },
  { code: 'CC', country: 'Cocos (Keeling) Islands', currency: 'AUD' },
  { code: 'CO', country: 'Colombia', currency: 'COP' },
  { code: 'KM', country: 'Comoros', currency: 'KMF' },
  { code: 'CG', country: 'Congo', currency: 'XAF' },
  { code: 'CD', country: 'Congo, Democratic Republic of', currency: 'CDF' },
  { code: 'CK', country: 'Cook Islands', currency: 'NZD' },
  { code: 'CR', country: 'Costa Rica', currency: 'CRC' },
  { code: 'CI', country: "Côte d'Ivoire", currency: 'XOF' },
  { code: 'HR', country: 'Croatia', currency: 'EUR' },
  { code: 'CU', country: 'Cuba', currency: 'CUP' },
  { code: 'CW', country: 'Curacao', currency: 'ANG' },
  { code: 'CY', country: 'Cyprus', currency: 'EUR' },
  { code: 'CZ', country: 'Czech Republic', currency: 'CZK' },
  { code: 'DK', country: 'Denmark', currency: 'DKK' },
  { code: 'DJ', country: 'Djibouti', currency: 'DJF' },
  { code: 'DM', country: 'Dominica', currency: 'XCD' },
  { code: 'DO', country: 'Dominican Republic', currency: 'DOP' },
  { code: 'EC', country: 'Ecuador', currency: 'USD' },
  { code: 'EG', country: 'Egypt', currency: 'EGP' },
  { code: 'SV', country: 'El Salvador', currency: 'USD' },
  { code: 'GQ', country: 'Equatorial Guinea', currency: 'XAF' },
  { code: 'ER', country: 'Eritrea', currency: 'ERN' },
  { code: 'EE', country: 'Estonia', currency: 'EUR' },
  { code: 'ET', country: 'Ethiopia', currency: 'ETB' },
  { code: 'FK', country: 'Falkland Islands (Malvinas)', currency: 'FKP' },
  { code: 'FO', country: 'Faroe Islands', currency: 'DKK' },
  { code: 'FJ', country: 'Fiji', currency: 'FJD' },
  { code: 'FI', country: 'Finland', currency: 'EUR' },
  { code: 'FR', country: 'France', currency: 'EUR' },
  { code: 'GF', country: 'France Guiana', currency: 'EUR' },
  { code: 'PF', country: 'French Polynesia', currency: 'XPF' },
  { code: 'TF', country: 'French Southern Territories', currency: 'EUR' },
  { code: 'GA', country: 'Gabon', currency: 'XAF' },
  { code: 'GM', country: 'Gambia', currency: 'GMD' },
  { code: 'GE', country: 'Georgia', currency: 'GEL' },
  { code: 'DE', country: 'Germany', currency: 'EUR' },
  { code: 'GH', country: 'Ghana', currency: 'GHS' },
  { code: 'GI', country: 'Gibraltar', currency: 'GIP' },
  { code: 'GR', country: 'Greece', currency: 'EUR' },
  { code: 'GL', country: 'Greenland', currency: 'DKK' },
  { code: 'GD', country: 'Grenada', currency: 'XCD' },
  { code: 'GP', country: 'Guadeloupe', currency: 'EUR' },
  { code: 'GU', country: 'Guam', currency: 'USD' },
  { code: 'GT', country: 'Guatemala', currency: 'GTQ' },
  { code: 'GG', country: 'Guernsey', currency: 'GBP' },
  { code: 'GN', country: 'Guinea', currency: 'GNF' },
  { code: 'GW', country: 'Guinea – Bissau', currency: 'XOF' },
  { code: 'GY', country: 'Guyana', currency: 'GYD' },
  { code: 'HT', country: 'Haiti', currency: 'HTG' },
  { code: 'HM', country: 'Heard and McDonald Islands', currency: 'AUD' },
  { code: 'VA', country: 'Holy See (Vatican City State)', currency: 'EUR' },
  { code: 'HN', country: 'Honduras', currency: 'HNL' },
  { code: 'HK', country: 'Hong Kong', currency: 'HKD' },
  { code: 'HU', country: 'Hungary', currency: 'HUF' },
  { code: 'IS', country: 'Iceland', currency: 'ISK' },
  { code: 'IN', country: 'India', currency: 'INR' },
  { code: 'ID', country: 'Indonesia', currency: 'IDR' },
  { code: 'IR', country: 'Iran, Islamic Republic Of', currency: 'IRR' },
  { code: 'IQ', country: 'Iraq', currency: 'IQD' },
  { code: 'IE', country: 'Ireland', currency: 'EUR' },
  { code: 'IM', country: 'Isle of Man', currency: 'GBP' },
  { code: 'IL', country: 'Israel', currency: 'ILS' },
  { code: 'IT', country: 'Italy', currency: 'EUR' },
  { code: 'JM', country: 'Jamaica', currency: 'JMD' },
  { code: 'JP', country: 'Japan', currency: 'JPY' },
  { code: 'JE', country: 'Jersey', currency: 'GBP' },
  { code: 'JO', country: 'Jordan', currency: 'JOD' },
  { code: 'KZ', country: 'Kazakhstan', currency: 'KZT' },
  { code: 'KE', country: 'Kenya', currency: 'KES' },
  { code: 'KI', country: 'Kiribati', currency: 'AUD' },
  { code: 'KP', country: 'Korea, Demo Peoples Repub of', currency: 'KPW' },
  { code: 'KR', country: 'Korea, Republic of', currency: 'KRW' },
  { code: 'KW', country: 'Kuwait', currency: 'KWD' },
  { code: 'KG', country: 'Kyrgyzstan', currency: 'KGS' },
  { code: 'LA', country: 'Lao Peoples Democratic Repub', currency: 'LAK' },
  { code: 'LV', country: 'Latvia', currency: 'EUR' },
  { code: 'LB', country: 'Lebanon', currency: 'LBP' },
  { code: 'LS', country: 'Lesotho', currency: 'LSL' },
  { code: 'LR', country: 'Liberia', currency: 'LRD' },
  { code: 'LY', country: 'Libyan Arab Jamahiriya', currency: 'LYD' },
  { code: 'LI', country: 'Liechtenstein', currency: 'CHF' },
  { code: 'LT', country: 'Lithuania', currency: 'EUR' },
  { code: 'LU', country: 'Luxembourg', currency: 'EUR' },
  { code: 'MO', country: 'Macao', currency: 'MOP' },
  { code: 'MK', country: 'Macedonia', currency: 'MKD' },
  { code: 'MG', country: 'Madagascar', currency: 'MGA' },
  { code: 'MW', country: 'Malawi', currency: 'MWK' },
  { code: 'MY', country: 'Malaysia', currency: 'MYR' },
  { code: 'MV', country: 'Maldives', currency: 'MVR' },
  { code: 'ML', country: 'Mali', currency: 'XOF' },
  { code: 'MT', country: 'Malta', currency: 'EUR' },
  { code: 'MH', country: 'Marshall Islands', currency: 'USD' },
  { code: 'MQ', country: 'Martinique', currency: 'EUR' },
  { code: 'MR', country: 'Mauritania', currency: 'MRU' },
  { code: 'MU', country: 'Mauritius', currency: 'MUR' },
  { code: 'YT', country: 'Mayotte', currency: 'EUR' },
  { code: 'MX', country: 'Mexico', currency: 'MXN' },
  { code: 'FM', country: 'Micronesia, Federated States of', currency: 'USD' },
  { code: 'MD', country: 'Moldova, Republic of', currency: 'MDL' },
  { code: 'MC', country: 'Monaco', currency: 'EUR' },
  { code: 'MN', country: 'Mongolia', currency: 'MNT' },
  { code: 'ME', country: 'Montenegro', currency: 'EUR' },
  { code: 'MS', country: 'Montserrat', currency: 'XCD' },
  { code: 'MA', country: 'Morocco', currency: 'MAD' },
  { code: 'MZ', country: 'Mozambique', currency: 'MZN' },
  { code: 'MM', country: 'Myanmar', currency: 'MMK' },
  { code: 'NA', country: 'Namibia', currency: 'NAD' },
  { code: 'NR', country: 'Nauru', currency: 'AUD' },
  { code: 'NP', country: 'Nepal', currency: 'NPR' },
  { code: 'NL', country: 'Netherlands', currency: 'EUR' },
  { code: 'AN', country: 'Netherlands Antilles', currency: 'ANG' },
  { code: 'NC', country: 'New Caledonia', currency: 'XPF' },
  { code: 'NZ', country: 'New Zealand', currency: 'NZD' },
  { code: 'NI', country: 'Nicaragua', currency: 'NIO' },
  { code: 'NE', country: 'Niger', currency: 'XOF' },
  { code: 'NG', country: 'Nigeria', currency: 'NGN' },
  { code: 'NU', country: 'Niue', currency: 'NZD' },
  { code: 'NF', country: 'Norfolk Island', currency: 'AUD' },
  { code: 'MP', country: 'Northern Mariana Islands', currency: 'USD' },
  { code: 'NO', country: 'Norway', currency: 'NOK' },
  { code: 'OM', country: 'Oman', currency: 'OMR' },
  { code: 'PK', country: 'Pakistan', currency: 'PKR' },
  { code: 'PW', country: 'Palau', currency: 'USD' },
  { code: 'PS', country: 'Palestinian Territory Occupied', currency: 'ILS' },
  { code: 'PA', country: 'Panama', currency: 'PAB' },
  { code: 'PG', country: 'Papua New Guinea', currency: 'PGK' },
  { code: 'PY', country: 'Paraguay', currency: 'PYG' },
  { code: 'PE', country: 'Peru', currency: 'PEN' },
  { code: 'PH', country: 'Philippines', currency: 'PHP' },
  { code: 'PN', country: 'Pitcairn', currency: 'NZD' },
  { code: 'PL', country: 'Poland', currency: 'PLN' },
  { code: 'PT', country: 'Portugal', currency: 'EUR' },
  { code: 'PR', country: 'Puerto Rico', currency: 'USD' },
  { code: 'QA', country: 'Qatar', currency: 'QAR' },
  { code: 'SS', country: 'Republic of South Sudan', currency: 'SSP' },
  { code: 'RE', country: 'Reunion', currency: 'EUR' },
  { code: 'RO', country: 'Romania', currency: 'RON' },
  { code: 'RU', country: 'Russian Federation', currency: 'RUB' },
  { code: 'RW', country: 'Rwanda', currency: 'RWF' },
  { code: 'GS', country: 'S Georgia S Sandwich Islands', currency: 'GBP' },
  { code: 'BL', country: 'Saint Barthelemy', currency: 'EUR' },
  { code: 'SH', country: 'Saint Helena', currency: 'SHP' },
  { code: 'KN', country: 'Saint Kitts and Nevis', currency: 'XCD' },
  { code: 'LC', country: 'Saint Lucia', currency: 'XCD' },
  { code: 'MF', country: 'Saint Martin French Part', currency: 'EUR' },
  { code: 'PM', country: 'Saint Pierre and Miquelon', currency: 'EUR' },
  { code: 'WS', country: 'Samoa', currency: 'WST' },
  { code: 'SM', country: 'San Marino', currency: 'EUR' },
  { code: 'ST', country: 'Sao Tome and Principe', currency: 'STN' },
  { code: 'SA', country: 'Saudi Arabia', currency: 'SAR' },
  { code: 'SN', country: 'Senegal', currency: 'XOF' },
  { code: 'RS', country: 'Serbia', currency: 'RSD' },
  { code: 'SC', country: 'Seychelles', currency: 'SCR' },
  { code: 'SL', country: 'Sierra Leone', currency: 'SLL' },
  { code: 'SG', country: 'Singapore', currency: 'SGD' },
  { code: 'SX', country: 'Sint Maarten (Dutch Part)', currency: 'ANG' },
  { code: 'SK', country: 'Slovakia', currency: 'EUR' },
  { code: 'SI', country: 'Slovenia', currency: 'EUR' },
  { code: 'SB', country: 'Solomon Islands', currency: 'SBD' },
  { code: 'SO', country: 'Somalia', currency: 'SOS' },
  { code: 'ZA', country: 'South Africa', currency: 'ZAR' },
  { code: 'ES', country: 'Spain', currency: 'EUR' },
  { code: 'LK', country: 'Sri Lanka', currency: 'LKR' },
  { code: 'VC', country: 'St. Vincent and the Grenadines', currency: 'XCD' },
  { code: 'SD', country: 'Sudan', currency: 'SDG' },
  { code: 'SR', country: 'Suriname', currency: 'SRD' },
  { code: 'SJ', country: 'Svalbard and Jan Mayen', currency: 'NOK' },
  { code: 'SZ', country: 'Swaziland', currency: 'SZL' },
  { code: 'SE', country: 'Sweden', currency: 'SEK' },
  { code: 'CH', country: 'Switzerland', currency: 'CHF' },
  { code: 'SY', country: 'Syrian Arab Republic', currency: 'SYP' },
  { code: 'TW', country: 'Taiwan', currency: 'TWD' },
  { code: 'TJ', country: 'Tajikistan', currency: 'TJS' },
  { code: 'TZ', country: 'Tanzania, United Republic of', currency: 'TZS' },
  { code: 'TH', country: 'Thailand', currency: 'THB' },
  { code: 'TL', country: 'Timor-Leste', currency: 'USD' },
  { code: 'TG', country: 'Togo', currency: 'XOF' },
  { code: 'TK', country: 'Tokelau', currency: 'NZD' },
  { code: 'TO', country: 'Tonga', currency: 'TOP' },
  { code: 'TT', country: 'Trinidad and Tobago', currency: 'TTD' },
  { code: 'TN', country: 'Tunisia', currency: 'TND' },
  { code: 'TR', country: 'Turkey', currency: 'TRY' },
  { code: 'TM', country: 'Turkmenistan', currency: 'TMT' },
  { code: 'TC', country: 'Turks and Caicos Is', currency: 'USD' },
  { code: 'TV', country: 'Tuvalu', currency: 'AUD' },
  { code: 'UG', country: 'Uganda', currency: 'UGX' },
  { code: 'UA', country: 'Ukraine', currency: 'UAH' },
  { code: 'AE', country: 'United Arab Emirates', currency: 'AED' },
  { code: 'UK', country: 'United Kingdom', currency: 'GBP' },
  { code: 'US', country: 'United States', currency: 'USD' },
  { code: 'UY', country: 'Uruguay', currency: 'UYU' },
  { code: 'UZ', country: 'Uzbekistan', currency: 'UZS' },
  { code: 'VU', country: 'Vanuatu', currency: 'VUV' },
  { code: 'VE', country: 'Venezuela, Bolivarian Republic', currency: 'VES' },
  { code: 'VN', country: 'Viet Nam', currency: 'VND' },
  { code: 'VG', country: 'Virgin Islands, British', currency: 'USD' },
  { code: 'VI', country: 'Virgin Islands, U.S.', currency: 'USD' },
  { code: 'WF', country: 'Wallis and Futuna', currency: 'XPF' },
  { code: 'EH', country: 'Western Sahara', currency: 'MAD' },
  { code: 'YE', country: 'Yemen', currency: 'YER' },
  { code: 'ZM', country: 'Zambia', currency: 'ZMW' },
  { code: 'ZW', country: 'Zimbabwe', currency: 'ZWL' },
];
